import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PublicProfilesContextService {
  private readonly _authRequired = signal(false);

  readonly authRequired = this._authRequired.asReadonly();

  requestAuth(): void {
    this._authRequired.set(true);
  }

  clearAuthRequest(): void {
    this._authRequired.set(false);
  }

  isPublicProfilesUrl(url: string): boolean {
    if (url.includes('/cvtheque/profiles/')) {
      return true;
    }
    if (url.includes('/offres-partagees') || url.includes('/offres-publiques')) {
      return true;
    }
    return window.location.pathname.includes('/cvtheque/profiles/')
      || window.location.pathname.includes('/offres-partagees')
      || window.location.pathname.includes('/offres-publiques');
  }
}
